import { allPeople, issues, monitors } from "../../fixtures";

const wait = async (timeout = 350) => {
  await new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
};

export const getAllPeople = async () => {
  await wait();
  return {
    people: allPeople,
  };
};

export const getAllIssueActivity = async (issueId: string) => {
  await wait();

  const issue = issues.find((i) => i.id === issueId);

  if (!issue) {
    throw new Error(`Could not find issue "${issueId}"`);
  }

  return {
    activity: issue.activity,
  };
};

export const getIssue = async (issueId: string) => {
  await wait();

  const issue = issues.find((i) => i.id === issueId);

  if (!issue) {
    throw new Error(`Could not find issue "${issueId}"`);
  }

  return { issue };
};

export const getMonitor = async (monitorId: string) => {
  await wait();

  const monitor = monitors.find((m) => m.id === monitorId);

  if (!monitor) {
    throw new Error(`Could not find monitor "${monitorId}"`);
  }

  return { monitor };
};

export const getMonitorIssues = async (monitorId: string) => {
  await wait();

  const monitor = monitors.find((m) => m.id === monitorId);

  if (!monitor) {
    throw new Error(`Could not find monitor "${monitorId}"`);
  }

  return { issues: issues.filter((i) => i.monitorId === monitorId) };
};
